import { useMutation, useQueryClient, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";
import toast from "react-hot-toast";
import createNotification from "shared/@utils/createNotification";
import { ENVIRONMENT_CONFIG } from "shared/globals";
const { coreApiUrl } = ENVIRONMENT_CONFIG;

export function useIncidents() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, status, isLoading, refetch } = useQuery(["incidents"], () =>
    makeAuthedRequest(`/incidents`, {
      method: "GET",
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    status,
    isLoading,
    refetch,
  };
}

// export function useIncident() {
//   const { makeAuthedRequest } = Auth.useContainer();

//   const fetchIncident = async (id) => {
//     const incident = makeAuthedRequest(`/incidents/${id}`)
//       .then(async (res) => {
//         if (res.ok) {
//           return res.json();
//         } else {
//           const json = await res.json();
//           throw new Error(json.message);
//         }
//       })
//       .then((json) => {
//         return json;
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//     return incident;
//   };
//   return { fetchIncident };
// }

export function useAddIncident() {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const addIncident = useMutation((incident) =>
    makeAuthedRequest(`/incidents`, {
      method: "POST",
      body: JSON.stringify(incident),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        throw new Error(body.error);
      }
    })
  );

  const { mutate } = useMutation(addIncident, {
    onSuccess: () => {
      queryClient.invalidateQueries("incident");
      createNotification({
        type: "success",
        title: "Saved",
        message: "A new incident was saved successfully.",
        autoDismiss: true,
      });
    },
    onError: (err) => {
      console.error(err);
      toast.error("Something went wrong!");
    },
  });

  return { addIncident, mutate };
}

export function useClearReminder() {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const clearReminderPut = useMutation(
    (reminderObject) =>
      makeAuthedRequest(`/incident/reminder-complete`, {
        method: "PUT",
        body: JSON.stringify(reminderObject),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("reminder");
        createNotification({
          type: "success",
          title: "Cleared",
          message: "Reminder Cleared",
          autoDismiss: true,
        });
      },
      onError: (err) => {
        console.error(err);
        toast.error("Something went wrong!");
      },
    }
  );

  return clearReminderPut;
}

export function useClearSuspensionReminder() {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const clearSuspensionReminderPut = useMutation(
    (reminderObject) =>
      makeAuthedRequest(`/incidents/pending-suspension`, {
        method: "PUT",
        body: JSON.stringify(reminderObject),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("reminder");
        createNotification({
          type: "success",
          title: "Cleared",
          message: "Reminder Cleared",
          autoDismiss: true,
        });
      },
      onError: (err) => {
        console.error(err);
        toast.error("Something went wrong!");
      },
    }
  );

  return clearSuspensionReminderPut;
}

export const useMemberInfo = () => {
  const { makeAuthedRequest } = Auth.useContainer();

  const fetchMember = async (iboNumber) => {
    const member = makeAuthedRequest(
      coreApiUrl + `/v1/membership/ibo/${iboNumber}`
    )
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .then((json) => {
        return json;
      })
      .catch((err) => {
        console.error(err);
      });
    return member;
  };

  const fetchAddress = async (iboNumber) => {
    const addresses = makeAuthedRequest(
      coreApiUrl + `/v1/membership/address/${iboNumber}`
    )
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .then((json) => {
        return json;
      })
      .catch((err) => {
        console.error(err);
      });
    return addresses;
  };

  return { fetchMember, fetchAddress };
};
